import { useState } from "react";

import { useAppDispatch, useAppSelector } from "../../store/reducer";
import {
  erOppgaveEksternOppgaveSelector,
  erOppgaveEksternSkjemaSelector,
  kanOppgavenBesvaresSelector,
  erInformasjonOppgaveSelector,
  erBetalingsOppgaveSelector,
} from "../../store/selectors/selectors-oppgaveDetaljer";
import { updateOppgaveStatus } from "../../store/thunks/thunk-oppgaveDetaljer";
import {
  kanUtforeOppgave,
  kanVisesInfoKnapp,
} from "../../utils/oppgaveTypeUtils";
import { redirectTilOppgave } from "../../utils/urlUtils";

import Button from "@helsenorge/designsystem-react/components/Button";
import Modal from "@helsenorge/designsystem-react/components/Modal";

import { useGetResources } from "../../hooks/useGetResources";

import styles from "../../styles/oppgave-detaljer.module.scss";
import { getOppgaveTypeTekst } from "../../utils/details-utils";
import { sporStartOppgave } from "utils/amplitude-utils";

export const UtforOppgaveVisning = (): React.JSX.Element | null => {
  const dispatch = useAppDispatch();

  const [showModalExternalPage, setShowModalExternalPage] = useState(false);
  const [showModalExternalPayment, setShowModalExternalPayment] =
    useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  const kanBesvares = useAppSelector(kanOppgavenBesvaresSelector);
  const oppgave = useAppSelector((state) => state.oppgaveDetaljer.oppgave!);
  const resources = useGetResources();
  const erEksternOppgave = useAppSelector(erOppgaveEksternOppgaveSelector);
  const erEksternSkjema = useAppSelector(erOppgaveEksternSkjemaSelector);
  const erSkjemaIOppgaveType = oppgave?.IntegrertVisning;
  const erInformasjonOppgave = useAppSelector(erInformasjonOppgaveSelector);
  const erBetalingsOppgave = useAppSelector(erBetalingsOppgaveSelector);
  const oppgaveTypeText = getOppgaveTypeTekst(oppgave, resources);
  const shouldSetShowModal =
    erEksternOppgave ||
    erEksternSkjema ||
    erInformasjonOppgave ||
    erBetalingsOppgave;

  const onShowModalSuccess = (): void => {
    if (oppgave) {
      sporStartOppgave(oppgave);
      redirectTilOppgave(oppgave);

      setShowModalExternalPage(false);
      setShowModalExternalPayment(false);
      setShowUpdateModal(true);

      if (kanUtforeOppgave(oppgave)) {
        dispatch(updateOppgaveStatus(oppgave.Id));
      }
    }
  };

  const onButtonClick = (): void => {
    if (shouldSetShowModal) {
      if (erBetalingsOppgave) {
        setShowModalExternalPayment(true);
      } else {
        setShowModalExternalPage(true);
      }
    } else {
      sporStartOppgave(oppgave);
      redirectTilOppgave(oppgave);
    }
  };

  const canRender =
    (kanBesvares || kanVisesInfoKnapp(oppgave)) &&
    oppgave?.KanInnloggetInnbyggerUtforeOppgave &&
    !erSkjemaIOppgaveType;
  const kanIkkeBesvareInfoOppgave = !kanBesvares && erInformasjonOppgave;

  return (
    <>
      {canRender ? (
        <Button
          className={styles.detaljer_seksjon}
          testId={
            kanIkkeBesvareInfoOppgave
              ? "testId-button-outline"
              : "testId-button-normal"
          }
          variant={kanIkkeBesvareInfoOppgave ? "outline" : undefined}
          onClick={(): void => onButtonClick()}
        >
          {oppgaveTypeText}
        </Button>
      ) : null}
      {showModalExternalPage && (
        <Modal
          title={resources?.redirect_Modal_Message_title || ""}
          description={
            kanIkkeBesvareInfoOppgave
              ? resources?.redirect_Modal_KanIkkeBesvare_Message
              : resources?.redirect_Modal_Message_description
          }
          primaryButtonText={resources?.redirect_modal_continue_button_text}
          secondaryButtonText={resources?.buttontext_cancel}
          onSuccess={(): void => onShowModalSuccess()}
          onClose={(): void => setShowModalExternalPage(false)}
        />
      )}
      {showModalExternalPayment && (
        <Modal
          title={resources?.modal_betaling_tittel || ""}
          description={resources?.modal_betaling_beskrivelse}
          primaryButtonText={resources?.buttontext_continue}
          secondaryButtonText={resources?.buttontext_cancel}
          onSuccess={(): void => onShowModalSuccess()}
          onClose={(): void => setShowModalExternalPayment(false)}
        />
      )}
      {kanBesvares && showUpdateModal && (
        <Modal
          title={resources?.changesMessage_title || ""}
          description={resources?.changesMessage_description}
          primaryButtonText={resources?.buttontext_update}
          onSuccess={(): void => window.location.reload()}
          onClose={(): void => setShowUpdateModal(false)}
          variant="warning"
          noCloseButton={true}
        />
      )}
    </>
  );
};
